import { SyntheticEvent, Fragment, memo } from 'react';
import cn from 'classnames';
import { FilterValue } from 'models/FilterValue';
import { ValueFacetFilter } from 'models/ValueFacetFilter';
import { FilterValueWithChildren } from 'models/FilterValueWithChildren';
import { Checkbox } from 'components/Shared/Form';
import connect from 'components/Shared/connect';
import { filterToggle } from 'components/Filter/actions';
import { filterChanged } from 'views/ProductlistPage/actions';
import { FilterProps } from './';
import { FilterHeader } from '../filterHeader';
import styles from './checkbox.scss';
import { ColourBox } from 'components/Shared/ColourBox';
import {
  mapSelectedFilterValuesToString,
  isFilterValueWithChildren
} from 'components/Filter/utils';

export type OwnProps = FilterProps & ValueFacetFilter;
interface MergedProps extends OwnProps {
  onChange: (
    filter: FilterValueWithChildren | FilterValue,
    parent?: FilterValueWithChildren
  ) => void;
  values: [FilterValueWithChildren | FilterValue];
}

const _CheckboxFilter = memo(
  ({ displayName, values, isOpen, active, toggleOpen, onChange, noHeader, name }: MergedProps) => {
    const handleChange =
      (filter: FilterValueWithChildren | FilterValue, parent?: FilterValueWithChildren) =>
      (e: SyntheticEvent) => {
        e.preventDefault();
        onChange(filter, parent);
      };

    const hasColour = name.includes('bhcolour');

    return (
      <div>
        {!noHeader && (
          <FilterHeader onClick={toggleOpen} border displayName={displayName}>
            {active && mapSelectedFilterValuesToString(values)}
          </FilterHeader>
        )}
        <div className={cn(styles.list, { [styles.hidden]: !isOpen })}>
          {values.map(filter => (
            <Fragment key={filter.displayName}>
              <Checkbox
                className={styles.filter}
                onChange={handleChange(filter)}
                appearance="primary"
                color="charcoal"
                checked={filter.selected}
              >
                {hasColour && <ColourBox className={styles.colorBox} colour={filter.value} />}
                <span>{filter.displayName}</span>
                <span className={styles.count}>({filter.count})</span>
              </Checkbox>

              {isFilterValueWithChildren(filter) &&
                filter.subValues.map(subValue => (
                  <Checkbox
                    key={subValue.displayName}
                    className={cn(styles.filter, styles.subFilter)}
                    onChange={handleChange(subValue, filter)}
                    checked={subValue.selected}
                  >
                    <span>{subValue.displayName}</span>
                    <span className={styles.count}>({subValue.count})</span>
                  </Checkbox>
                ))}
            </Fragment>
          ))}
        </div>
      </div>
    );
  }
);

export const CheckboxFilter = connect<MergedProps, OwnProps>(
  undefined,
  (dispatch, { name }: FilterProps) => ({
    onChange: (filter: FilterValueWithChildren | FilterValue, parent?: FilterValueWithChildren) => {
      const action = { facet: name, filter, parent };
      dispatch(filterToggle(action));
      void dispatch(filterChanged(action));
    }
  })
)(_CheckboxFilter);
